"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../../bind");
var offer_create_form_1 = require("@reverbdotcom/commons/dist/offers/offer_create_form");
var modal_1 = require("@reverbdotcom/commons/dist/components/modal");
var offer_listing_sidebar_1 = require("@reverbdotcom/commons/dist/offers/offer_listing_sidebar");
var rql_1 = require("../../schemas/rql");
var body_input_1 = require("./body_input");
var url_helpers_1 = require("../shared/url_helpers");
var I18n = require("i18n-js");
// Wraps the BodyInput and CreateOfferButton components, and syncs the state between them,
// so if you start typing a message and then decide to include an offer, your message
// (and photos) persists to the offer modal.
var MessageForm = /** @class */ (function (_super) {
    tslib_1.__extends(MessageForm, _super);
    function MessageForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOfferModalOpen: false,
            input: {
                message: '',
            },
            photos: [],
        };
        return _this;
    }
    MessageForm.prototype.handleMessageChange = function (message) {
        this.setState({
            input: tslib_1.__assign(tslib_1.__assign({}, this.state.input), { message: message }),
        });
    };
    MessageForm.prototype.handlePhotosChange = function (photos) {
        this.setState({ photos: photos });
    };
    MessageForm.prototype.handleOfferChange = function (offer) {
        this.setState({
            input: tslib_1.__assign(tslib_1.__assign({}, this.state.input), offer),
        });
    };
    MessageForm.prototype.toggleOfferModal = function () {
        this.setState({
            isOfferModalOpen: !this.state.isOfferModalOpen,
        });
    };
    MessageForm.prototype.handleCloseOfferModal = function () {
        this.setState({ isOfferModalOpen: false });
    };
    MessageForm.prototype.handleSuccess = function () {
        this.setState({ isOfferModalOpen: false });
        window.location.reload();
    };
    Object.defineProperty(MessageForm.prototype, "additionalMutationParams", {
        get: function () {
            return {
                message: this.state.input.message,
                conversation: {
                    listingId: this.props.listingId,
                    photos: this.photoData,
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessageForm.prototype, "photoData", {
        get: function () {
            return this.state.photos.map(function (photo) { return ({
                publicId: photo.publicId,
                version: photo.version,
                width: photo.width,
                height: photo.height,
                format: photo.format,
                resourceType: photo.resourceType,
                originalFilename: photo.originalFilename,
                transformation: photo.transformation,
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessageForm.prototype, "sharedBodyInputProps", {
        get: function () {
            return {
                message: this.state.input.message,
                onChange: this.handleMessageChange,
                photos: this.state.photos,
                onPhotosChange: this.handlePhotosChange,
                productId: this.props.listingId,
                isSeller: this.props.isSeller,
                analyticsSource: this.props.analyticsSource,
                photoUploadOptions: this.props.photoUploadOptions,
                hideListingSearch: this.props.hideListingSearch,
            };
        },
        enumerable: true,
        configurable: true
    });
    MessageForm.prototype.renderOfferMessageInput = function () {
        return (React.createElement(body_input_1.ControlledBodyInput, tslib_1.__assign({}, this.sharedBodyInputProps, { isRequired: false, inputNamespace: "", "data-offer-body-input": true })));
    };
    MessageForm.prototype.renderOfferSidebar = function () {
        return (React.createElement(offer_listing_sidebar_1.ConnectedOfferListingSidebar, { isDisplayed: this.state.isOfferModalOpen, isSeller: this.props.isSeller, listingId: this.props.listingId, shopChannel: rql_1.core_apimessages_Channel.REVERB, listingUrlGenerator: url_helpers_1.default.listingPagePath }));
    };
    MessageForm.prototype.renderIncludeOffer = function () {
        if (!this.props.canIncludeOffer) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement("button", { className: "button button--blue width-100", onClick: this.toggleOfferModal, type: "button", "data-include-offer-button": true }, I18n.t('discovery.messages.messageForm.includeOffer')),
            React.createElement(modal_1.default, { onRequestClose: this.handleCloseOfferModal, isOpen: this.state.isOfferModalOpen, headerTitle: I18n.t('discovery.messages.messageForm.offerModalHeader'), sidebarContent: this.renderOfferSidebar(), paddedBody: true, newClose: true, "data-offer-modal": true },
                React.createElement(offer_create_form_1.default, { isSeller: this.props.isSeller, recipientUuid: this.props.recipientUuid, listingId: this.props.listingId, shopChannel: rql_1.core_apimessages_Channel.REVERB, onSuccess: this.handleSuccess, onCancel: this.handleCloseOfferModal, isDisplayed: this.state.isOfferModalOpen, offer: this.state.input, onChange: this.handleOfferChange, messageInput: this.renderOfferMessageInput(), additionalMutationParams: this.additionalMutationParams }))));
    };
    MessageForm.prototype.render = function () {
        return (React.createElement("div", { className: "g-container" },
            React.createElement("div", { className: "g-col-8 g-col-mobile-12" },
                React.createElement(body_input_1.ControlledBodyInput, tslib_1.__assign({}, this.sharedBodyInputProps, { isRequired: true, inputNamespace: "message", "data-message-body-input": true }))),
            React.createElement("div", { className: " g-col-4 g-col-mobile-12 mb-1 mobile-mt-1" }, this.renderIncludeOffer())));
    };
    tslib_1.__decorate([
        bind_1.default
    ], MessageForm.prototype, "handleMessageChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], MessageForm.prototype, "handlePhotosChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], MessageForm.prototype, "handleOfferChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], MessageForm.prototype, "toggleOfferModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], MessageForm.prototype, "handleCloseOfferModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], MessageForm.prototype, "handleSuccess", null);
    return MessageForm;
}(React.Component));
exports.default = MessageForm;
//# sourceMappingURL=message_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/messages/message_form.js
// module id = DVRk
// module chunks = 20 21